
<letter-generation-library [primaryData]="primaryData" (onDialogClose)="handleDialogClose()" 
style="width:100%" [simplifyH1b]="true"></letter-generation-library>
